import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';

import {
  Text,
  Space,
  Button,
  Modal,
  ModalContent,
  ModalDescription,
  Conditional,
} from '@cashfree-intl/coherent';

import * as animationData from 'animation/settlements-success.json';
import { CURRENCY_SYMBOL } from 'utils/constants';
import { numberWithCommas, roundOffNumber } from 'utils/common';
import { ACTIVE, CREATED } from '../constants';
import { formatInstantSettlementsDailyLimit } from '../utils';
import CustomIcons from '../../../components/CustomIcons';

function InstantSettlementsActivationModal({
  config,
  closeModal,
  onDemandStatus,
  registrationStatus,
}) {
  const defaultOptions = {
    loop: false,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const { limit, suffix } = formatInstantSettlementsDailyLimit(
    config.workingDayLimitInLakhs,
  );

  return (
    <Modal $maxWidth={480} open>
      <ModalContent>
        <ModalDescription>
          <div className="text-center">
            <Conditional if={registrationStatus === CREATED}>
              <CustomIcons componentName="GREEN_TICK_BIG" />
              <Text variant="h20" strong className="mb-2 mt-2">
                Instant Settlement request has been noted
              </Text>
            </Conditional>
            <Conditional if={registrationStatus !== CREATED}>
              <Lottie options={defaultOptions} height={100} width={100} />
              <Text variant="h20" strong className="mb-2">
                Instant Settlements Activated
              </Text>
              <Conditional if={onDemandStatus !== ACTIVE}>
                <Space
                  alignItems="center"
                  gap={3.25}
                  className="instant-settlements-activation-meta"
                >
                  <div>
                    <Text
                      variant="b14"
                      color="bodyLight"
                      className="first-item"
                    >
                      Max Daily Limit
                    </Text>
                    <Conditional if={config.workingDayRate > 0}>
                      <Text variant="b14" color="bodyLight">
                        Charges Applicable
                      </Text>
                    </Conditional>
                  </div>
                  <div>
                    <Text variant="b14" strong className="first-item">
                      <span className="w-500">{CURRENCY_SYMBOL.INR}</span>{' '}
                      {numberWithCommas(limit)} {suffix}{' '}
                      <Conditional if={onDemandStatus !== ACTIVE}>
                        (Limited Mode)
                      </Conditional>
                    </Text>
                    <Conditional if={config.workingDayRate > 0}>
                      <Text variant="b14" strong>
                        {roundOffNumber(config.workingDayRate)}% + GST
                      </Text>
                    </Conditional>
                  </div>
                </Space>
              </Conditional>
              <Conditional if={onDemandStatus === ACTIVE}>
                <Space
                  alignItems="center"
                  gap={3.25}
                  className="instant-settlements-activation-meta od-activated"
                >
                  <div>
                    <Conditional if={config.workingDayRate > 0}>
                      <Text
                        variant="b14"
                        color="bodyLight"
                        className="first-item"
                      >
                        Working Day Charges
                      </Text>
                    </Conditional>
                    <Conditional if={config.holidayRate > 0}>
                      <Text variant="b14" color="bodyLight">
                        Holiday Charges
                      </Text>
                    </Conditional>
                  </div>
                  <div>
                    <Conditional if={config.workingDayRate > 0}>
                      <Text variant="b14" strong className="first-item">
                        {roundOffNumber(config.workingDayRate)}% + GST
                      </Text>
                    </Conditional>
                    <Conditional if={config.holidayRate > 0}>
                      <Text variant="b14" strong>
                        {roundOffNumber(config.holidayRate)}% + GST
                      </Text>
                    </Conditional>
                  </div>
                </Space>
              </Conditional>
            </Conditional>
            <Button
              className={`${
                registrationStatus === CREATED
                  ? 'mt-2'
                  : `${onDemandStatus === ACTIVE ? 'mt-4' : 'mt-7'}`
              } mb-1`}
              primary
              onClick={closeModal}
              data-event-name="Primary_Button_Close"
            >
              Close
            </Button>
          </div>
        </ModalDescription>
      </ModalContent>
    </Modal>
  );
}

InstantSettlementsActivationModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
  onDemandStatus: PropTypes.any.isRequired,
  registrationStatus: PropTypes.string.isRequired,
};

export default InstantSettlementsActivationModal;
